import { render, staticRenderFns } from "./modelReview.vue?vue&type=template&id=7e2b2efe"
import script from "./modelReview.vue?vue&type=script&lang=js"
export * from "./modelReview.vue?vue&type=script&lang=js"
import style0 from "./modelReview.vue?vue&type=style&index=0&id=7e2b2efe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports